import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SubscriptionService } from 'src/app/features/subscription/subscription.service';
import { RegistrationService } from '../../../registration.service';

import { UrlParamsService } from 'src/app/shared/services/url-params.service';
import { ProgressBarMode, MatProgressBarModule } from '@angular/material/progress-bar';
import { MinProjectDTO } from 'src/app/features/subscription/types/MinProjectDTO';

@Component({
  selector: 'app-survey-123-confirmation',
  imports: [MatProgressBarModule],
  templateUrl: './survey-123-confirmation.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './survey-123-confirmation.component.scss',
})
export class Survey123ConfirmationComponent implements OnInit {
  projectInfo: MinProjectDTO | null = null;
  progressValue = 0;
  timerInterval: any;
  survey123Url: string = '';
  showProgressBar: boolean = true;

  constructor(
    private registrationService: RegistrationService,
    private urlParamsService: UrlParamsService
  ) {}

  ngOnInit(): void {
    this.registrationService.projectInfo$.subscribe({
      next: (projectInfo) => {
        this.projectInfo = projectInfo;

        const state = history.state;
        if (state && state.survey123Url) {
          this.survey123Url = state.survey123Url;
        }

        this.startProgressBar();
      },
      error: (error) => {
        console.error('Error fetching meeting info:', error);
      },
    });
  }

  startProgressBar(): void {
    let progress = 0;
    this.timerInterval = setInterval(() => {
      if (progress < 100) {
        progress += 2;
        this.progressValue = progress;
      } else {
        clearInterval(this.timerInterval);
        this.redirectToSurvey();
      }
    }, 100);
  }

  cancelRedirect(): void {
    clearInterval(this.timerInterval);
    this.showProgressBar = false;
  }

  redirectToSurvey(): void {
    window.location.href = this.survey123Url;
  }
}
